import React, { useEffect, useState } from "react";
import { Container, Button, Card, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { myBusinessUpdate } from "../../Redux/Settings/myBusiness/actions";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

const FAQs = ({ onFAQDataUpdate }) => {
  const [faqs, setFAQs] = useState([]);
  const [newFAQ, setNewFAQ] = useState({ question: "", answer: "" });
  const [editingIndex, setEditingIndex] = useState(null);
  const [validated, setValidated] = useState(false);

  const dispatch = useDispatch();
  const businessData = useSelector(state => state.myBusinessReducer.data)
  const user = useSelector(state => state.authReducer.data)

  const addFAQ = (event) => {
    if (newFAQ.question && newFAQ.answer) {
      if (editingIndex !== null) {
        const updatedFAQs = [...faqs];
        updatedFAQs[editingIndex] = {
          question: newFAQ.question,
          answer: newFAQ.answer,
        };
        setFAQs(updatedFAQs);
        setEditingIndex(null);
        onFAQDataUpdate(updatedFAQs);
        const finalPayload = {
          faqs: updatedFAQs,
        };

        try {
          myBusinessUpdate(dispatch, user.accountID, finalPayload);
        } catch (e) {
        }
      } else {
        const updatedFAQs = [
          ...faqs,
          { question: newFAQ.question, answer: newFAQ.answer },
        ];
        setFAQs(updatedFAQs);

        const finalPayload = {
          faqs: updatedFAQs,
        };

        try {
          myBusinessUpdate(dispatch, user.accountID, finalPayload);
        } catch (e) {
        }

        onFAQDataUpdate(updatedFAQs);
      }

      setNewFAQ({ question: "", answer: "" }); // Clear the fields after successful update
    }
  };

  const editFAQ = (index) => {
    setNewFAQ({ ...faqs[index] });
    setEditingIndex(index);
  };

  const deleteFAQ = (index) => {
    const updatedFAQs = [...faqs];
    updatedFAQs.splice(index, 1);
    setFAQs(updatedFAQs);
    setEditingIndex(null);
    onFAQDataUpdate(updatedFAQs);

    const finalPayload = {
      "faqs": updatedFAQs
    };

    try {
      myBusinessUpdate(dispatch, user.accountID, finalPayload)

    } catch (e) {
    }
  };
  const submitFaqs = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      toast.error("Please fill all the fields", toastConfig);
    }
    else {
      toast.success("Updated!", toastConfig);
    }
  }

  const toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
  };

  useEffect(() => {
    if (businessData.faqs) {
      setFAQs(Object.values(businessData.faqs));
    }
  }, [businessData.faqs]);
  return (
    <Container className='mt-5' style={{ overflow: "auto", height: "78vh" }}>
      <h4 className='main-h4-tag-large mb-3'>FAQs Section</h4>
      <Form
        noValidate validated={validated}
        onSubmit={addFAQ}
        className="w-75"
      >
        <Form.Group controlId="formQuestion" className="mt-3 custom-p-tag">
          <Form.Label>Question</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your question"
            value={newFAQ.question}
            onChange={(e) => setNewFAQ({ ...newFAQ, question: e.target.value })}
            className="p-2"
            required
          />
        </Form.Group>

        <Form.Group controlId="formAnswer" className="mt-3 custom-p-tag">
          <Form.Label>Answer</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter your answer"
            value={newFAQ.answer}
            onChange={(e) => setNewFAQ({ ...newFAQ, answer: e.target.value })}
            className="p-2"
            required
          />
        </Form.Group>

        <Button variant="primary" className="custom-button" onClick={addFAQ}>
          {editingIndex !== null ? "Update" : "Add"} FAQ
        </Button>
        {/* <Button variant="primary" className="custom-button float-right" onClick={submitFaqs}>
          Submit
        </Button> */}
      </Form>
      <Accordion allowZeroExpanded className="w-75">
        {faqs.map((item, index) => (
          <AccordionItem key={item.uuid}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <strong>Question: </strong> {item.question}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <strong>Answer: </strong> {item.answer}
              <div className="d-flex justify-content-end">
                <Button variant="warning" onClick={() => editFAQ(index)} className="custom-button">
                  Update
                </Button>{" "}
                <Button variant="danger" onClick={() => deleteFAQ(index)} className="custom-button">
                  Delete
                </Button>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Container>

  );
};

export default FAQs;